import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { DocumentTypeService } from '../documenttype/documenttype.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { DocumentType } from './documenttype';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DepartmentService } from '../department/department.service';
import { AgencyService } from '../agency/agency.service';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-documenttype',
  templateUrl: './documenttype.component.html',
  styleUrls: ['./documenttype.component.css'],
  providers: [DocumentTypeService, ToastrService]
})
export class DocumenttypeComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Document Type';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  _doctypelist: any; agencyList: any;
  documenttypeid: number; userid: number; confmsg: string; postresult: boolean;
  _operation: string;
  p: number = 1; msg: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  modalRef: BsModalRef;
  public searchText: string;
  key: string = 'documenttype'; //set default
  reverse: boolean = false;
  //formgroup
  doctypeForm: FormGroup;
  DocTypes: DocumentType[] = [];
  DocTypesactive: DocumentType[] = [];
  DocType: DocumentType;
  submitted = false;

  constructor(private _router: Router,
    private _doctypeService: DocumentTypeService,
    private modalService: BsModalService,
    private toastr: ToastrService, private router: Router,
    private dialogService: DialogService,
    private formBuilder: FormBuilder, private agencyService: AgencyService,
    private localService: LocalService ) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('DocumentType_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentType_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentType_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentType_action');
    } }

  

  ngOnInit() {
    //formvalidation
    this.doctypeForm = this.formBuilder.group(
      {
        documenttypeid: [''],
        documenttype: ['', Validators.required],
        description: [''],
        agencyid: ['', Validators.required],
        active: ['', Validators.required]
      });
    this.searchText = '';
    this.Loaddocumenttypelist();
    this.GetActiveAgencies();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.modalRef.hide();
  }

  get formdata() { return this.doctypeForm.controls; }

  PostDoctype(doctp: DocumentType) {
    this.submitted = true;
    //if (this.doctypeForm.invalid) {
    //  // console.log(this.formdata);
    //  //console.log(this.doctypeForm.errors);
    //  //this.toastr.error('Required fields cannot be empty');
    //}

    if (this.doctypeForm.value.agencyid == 0) {
      this.toastr.warning('Please select the Agency')
      return;
    }
    if (((doctp.documenttype.trim() == undefined) || (doctp.documenttype.trim() == '')) ) {
      this.toastr.error('Document Type name should not be empty');
      return;
    }
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    //method to add the entered doctype information
    if (this._operation == 'add') {
      doctp.createdby = this.userid;
      doctp.documenttypeid = 0;
      this._doctypeService.Post(doctp).subscribe((res) => {
        if (res != undefined) {
          if (res.body != 0) {
            this.Loaddocumenttypelist();
            this.modalRef.hide();
            this.doctypeForm.reset();
            this.toastr.success('Data added successfully');
          }
          else { this.toastr.warning('Record already exists'); }
        }
      }, error => {
        this.toastr.error(JSON.stringify(error));
        this.postresult = false;
      });
    }
    else if (this._operation = 'update') {
      this.submitShow = true;
      doctp.modifiedby = this.userid;
      this._doctypeService.Put(doctp).subscribe((res) => {
        if (res != undefined) {
          if (res.body != 0) {
            this.Loaddocumenttypelist();
            this.modalRef.hide();
            this.doctypeForm.reset();
            this.toastr.success('Data updated successfully');

          }
          else { this.toastr.warning('Record already exists'); }
        }
      }, error => {
        this.toastr.error(error.error.message); this.postresult = false;
      });
    }



  }

  //method to open the modal popup
  OpenConfirmTemplate(doctp, template: TemplateRef<any>) {
    if (doctp.active == 0) 
      this.confmsg = "activate";      
    else 
      this.confmsg = "deactivate";      
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    doctp.modifiedby = this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          if (doctp.active == 0) {          
            doctp.active = 1;
            this.msg = "Record activated successfully";
          }
          else {           
            doctp.active = 0;
            this.msg = "Record deactivated successfully";
          }
          this._doctypeService.Delete(doctp).subscribe((res) => {
            if (res != undefined) {
              if (res.body != 0) {
                this.Loaddocumenttypelist();
                this.toastr.success(this.msg);
              }
              else { this.toastr.warning('Data not updated...'); }
            }
          }, error => {
            this.toastr.error(error.error.message);
          });
        }
      });

  }
  
  //load the active agency dropdown
  GetActiveAgencies() {
    this.agencyService.getActiveAgencies().subscribe(res => { this.agencyList = res; },
      error => { this.toastr.error('Error while getting Agency Data') })
  }
  
  //method to load all the exisitng role list
  Loaddocumenttypelist() {
    
    this._doctypeService.Get().subscribe((res) => {
      this.DocTypes = [];
      this.DocTypesactive = [];
      if (res != undefined) {
       
        this.DocTypes = res;
        if (this.showallstatus == true) {
          this.DocTypes.forEach(data => {
            if (data.active == 1) {
              this.DocTypesactive.push(data);
            }
          });
          this.DocTypes = [];
          this.DocTypes = this.DocTypesactive;
        }
      }
    }, error => {
      this.toastr.error('error while getting document type Data');
    });
  };

  getactiveinactive(showallp) {
    this.DocTypesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.DocTypes.forEach(data => {
        if (data.active == 1) {
          this.DocTypesactive.push(data);
        }
      });
      this.DocTypes = [];
      this.DocTypes = this.DocTypesactive;
    }
    else {
      this.showall = true;
      this.DocTypes = [];
      this.Loaddocumenttypelist();
    }
  }

  //method to open the modal popup
  openModal(template: TemplateRef<any>, type, DocType?: DocumentType) {
    this._operation = type
    if (type == 'update') {
      this.doctypeForm.controls['documenttypeid'].setValue(DocType.documenttypeid);
      this.doctypeForm.controls['documenttype'].setValue(DocType.documenttype);
      this.doctypeForm.controls['description'].setValue(DocType.description);
      this.doctypeForm.controls['agencyid'].setValue(DocType.agencyid);
      this.doctypeForm.controls['active'].setValue(DocType.active);
      this.DocType = DocType;
    }
    if (type == 'add') {
      this.doctypeForm.reset();
      this.doctypeForm.controls['active'].setValue(1);
      this.doctypeForm.controls['agencyid'].setValue(0);
    }
    this.modalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

  changed(evt) {
    if (evt.target.checked == false)
      this.doctypeForm.value.active = 0;
    else
      this.doctypeForm.value.active = 1;
  }

  //dropdown changed event
  changeagency(eve) {
    this.doctypeForm.value.agencyid.setValue(eve.target.value, {
      onlySelf: true
    });
  }

}
